import WishGridItem from "./wish-grid-item/WishGridItem";
import {getRandomNumber} from "../../../../util/utils";
import WishGridItemSkeleton from "./wish-grid-item-skeleton/WishGridItemSkeleton";
import {IWishesResponse} from "../../../../store/wish/Helper";
import {FC, memo, useMemo} from "react";
import Grid from "@mui/material/Grid";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";

interface Props {
    wishes: IWishesResponse
    handleOpenWishDetails: (wishId: string) => void
    loading: boolean
    sx?: SxProps<Theme>
}

const WishGrid: FC<Props> = (props) => {
    const renderWishes = useMemo(() => props.wishes.data.map((wish) => (
        <WishGridItem
            key={wish.id}
            wish={wish}
            handleOpenWishDetails={props.handleOpenWishDetails}
        />
    )), [props.wishes.data, props.handleOpenWishDetails])

    const skeletonCount = useMemo(() => getRandomNumber(3, 8), [])
    const renderWishSkeletons = useMemo(
        () => Array.from(Array(skeletonCount).keys()).map((_, idx) => (
            <WishGridItemSkeleton key={`wish-grid-item-skeleton-${idx}`}/>
        )),
        [skeletonCount]
    )
    return (
        <Grid container justifyContent="space-around" sx={{...props.sx}}>
            {renderWishes}
            {props.loading ? renderWishSkeletons : null}
        </Grid>
    )
}

export default memo(WishGrid)
